/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "laundryapi",
            "endpoint": "https://my9ls4gj1g.execute-api.eu-west-2.amazonaws.com/demo",
            "region": "eu-west-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://rs5o3ljbtjcwtljlkmsysepzji.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-ee2wfilpyngttflwus32jkoqpq",
    "aws_cognito_identity_pool_id": "eu-west-2:fb2218be-7410-4a67-a66c-aaf1c1243d45",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_4ZIMv5jnJ",
    "aws_user_pools_web_client_id": "7ujtbc68uqdme93mem5ed42qls",
    "oauth": {
        "domain": "googlesignin-demo.auth.eu-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://www.do-gooder.co.uk/",
        "redirectSignOut": "http://localhost:3000/,https://www.do-gooder.co.uk/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "laundry-app-20210328000328-hostingbucket-demo",
    "aws_content_delivery_bucket_region": "eu-west-2",
    "aws_content_delivery_url": "https://d17k1tqtd80y1z.cloudfront.net",
    "aws_user_files_s3_bucket": "laundryappb3ead5e3a8b8480e8c40eabfcd65827a02416-demo",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
